// @flow
export { default } from './ProductTemplate';



// WEBPACK FOOTER //
// ./src/components/product/ProductTemplate/index.js